import React from "react";
import {Card} from "@elcimai/webankdesignsystem";
import {Content, FeatureStyle, Text, Title} from "./FeatureKey.css";

export interface FeatureKeyProps {
    title: string
    description1: string
    description2: string
}

const FeatureKey = ({title, description1, description2}:FeatureKeyProps) => {

    return (

            <Card className={FeatureStyle} isBehind={false} shadow={true}>
                <div className={Content}>
                    <p className={Title}>{title}</p>
                    <p className={Text}>{description1}</p>
                    <p className={Text}>{description2}</p>
                </div>
            </Card>

    );
}

export default FeatureKey